module.exports = "/images/people.svg?a63ad6163f2395e7b145d25135879628";